import { post } from "../../../utils/fetch";

/**
 * OrderDraftSaveReq
 */

export var apiTaskDraftSave = function apiTaskDraftSave(data) {
  return post({
    url: '/flow/core/saveDraft',
    data: data,
    loading: false,
    errorTip: false
  });
};